import { faAt, faBriefcase, faFile, faUser } from '@fortawesome/free-solid-svg-icons';
import { faPenNib } from '@fortawesome/free-solid-svg-icons/faPenNib';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
const NavMenu = () => {
    return (
        <header className="flex flex-col md:justify-center mx-2 mt-1 md:mt-0 sticky top-0  z-10">
            <nav>
                <ul className="flex md:flex-col space-x-4 md:space-x-0 md:space-y-2 justify-center md:justify-start bg-white p-2 rounded">
                    <Link to="/" className="text-black hover:text-blue-700"> <li className='flex flex-col items-center text-xs' >
                        <FontAwesomeIcon icon={faUser} />
                        About
                    </li>
                    </Link>
                    <Link to="/resume" className="text-black hover:text-blue-700"> <li className='flex flex-col items-center text-xs' >
                        <FontAwesomeIcon icon={faFile} />
                        Resume  </li>
                    </Link>

                    <Link to="/work" className="text-black hover:text-blue-700">  <li className='flex flex-col items-center text-xs' >
                        <FontAwesomeIcon icon={faBriefcase} />
                        Work
                    </li>
                    </Link>
                    <Link to="/blog" className="text-black hover:text-blue-700">   <li className='flex flex-col items-center text-xs' >
                        <FontAwesomeIcon icon={faPenNib} />
                        Blog
                    </li>
                    </Link>
                    <Link to="/contact" className="text-black hover:text-blue-700">  <li className='flex flex-col items-center text-xs' >
                        <FontAwesomeIcon icon={faAt} />
                        Contact
                    </li>
                    </Link>


                </ul>
            </nav>
        </header>
    );
};

export default NavMenu;